import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';

const ExtraDataDetails = ({ extraData }) => {
  if (!extraData) return null;

  // Define label mappings for readability
  const labels = {
    AgeOfBuilding: 'Age of Building',
    Balcony: 'Balconies',
    Bathrooms: 'Bathrooms',
    Bedrooms: 'Bedrooms',
    LandAreaInSqFt: 'Land Area (SqFt)',
    NoOfFloors: 'Number of Floors',
    ParkingAvailable: 'Parking Available',
    ParkingType: 'Parking Type',
    PowerBackUp: 'Power Backup',
    WaterSupply: 'Water Supply',
  };

  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
      <Typography  variant="h6"
      sx={{ fontWeight: 600, color: "#13216e" }} gutterBottom>
        Villa Details
      </Typography>

      <Grid container spacing={2}>
        {Object.entries(labels).map(([key, label]) => (
          extraData[key] ? (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <Box>
                <Typography variant="body2" color="text.secondary">
                  {label}
                </Typography>
                <Typography variant="subtitle1" fontWeight="bold">
                  {extraData[key]}  
                </Typography>
              </Box>
            </Grid>
          ) : null
        ))}
      </Grid>
    </Paper>
  );
};

export default ExtraDataDetails;
